import { createReducer, on } from '@ngrx/store';
import { Tariff } from 'brain-data/model/tariff.model';
import { loadTariffs, loadTariffsError, loadTariffsSuccess } from '../actions/tariff.action';

export default interface TariffState {
  tariffs: Tariff[];
  loading: boolean;
  loaded: boolean;
  error?: Error;
}

export const initialState: TariffState = {
  tariffs: [],
  loading: false,
  loaded: false,
  error: undefined,
};

export const reducer = createReducer(
  initialState,
  on(loadTariffs, (state): TariffState => ({ ...state, loading: true, error: undefined })),
  on(loadTariffsSuccess, (state, { tariffs }): TariffState => ({
    ...state,
    tariffs,
    loading: false,
    loaded: true,
  })),
  on(loadTariffsError, (state, { error }): TariffState => ({
    ...state,
    loading: false,
    error,
  })),
);
